import SystemCompletionService from './system.completion.service'

export default {
  SystemCompletionService,
}